export const SEND_FORM_WAITLIST_REQUEST = 'SEND_FORM_WAITLIST_REQUEST';
export const SEND_FORM_WAITLIST_RESPONSE = 'SEND_FORM_WAITLIST_RESPONSE';
export const SEND_FORM_WAITLIST_FAILURE = 'SEND_FORM_WAITLIST_FAILURE';
export const GET_FORM_WAITLIST_REQUEST = 'GET_FORM_WAITLIST_REQUEST';
export const GET_FORM_WAITLIST_RESPONSE = 'GET_FORM_WAITLIST_RESPONSE';
export const GET_FORM_WAITLIST_FAILURE = 'GET_FORM_WAITLIST_FAILURE';
